import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { LandingSettings, TrackingEntry } from 'src/services/groups';

interface SiteConfig {
  logo: string;
  groupType?: number;
  webClientType?: number;
  theme: string;
  images: {
    logo: string;
    welcome: string;
    emailHeader: string;
    emailFooter: string;
    background?: string;
  };
  emails: { primary: string; secondary: string | null };
  phones: { primary: string; secondary: string | null };
  welcomeTitle: string;
  welcomeDescription: string;
  registrationTitle?: string;
  registrationText?: string;
  plans: number[];
  phqEnabled?: boolean;
  skin?: string | null;
  landing?: LandingSettings | null;
  tracking?: TrackingEntry[] | null;
}

interface GeneralStore {
  siteConfig: SiteConfig | null;
  isLoadingConfig: boolean;
  /**
   * True once a branding fetch has FAILED and left the host type unresolved
   * (no persisted `siteConfig` to fall back on). The W2 host gate reads this to
   * fail CLOSED rather than leave a possibly-W2 host fully open on an outage.
   * Never persisted — always re-derived per session.
   */
  configLoadFailed: boolean;
  setSiteConfig: (siteConfig: SiteConfig) => void;
  setIsLoadingConfig: (isLoading: boolean) => void;
  setConfigLoadFailed: (failed: boolean) => void;
}

export const useGeneralStore = create<GeneralStore>()(
  persist(
    (set) => ({
      siteConfig: null,
      isLoadingConfig: true,
      configLoadFailed: false,
      setSiteConfig: (siteConfig: SiteConfig) => {
        set({ siteConfig });
        if (siteConfig?.theme) {
          document.body.classList.add(siteConfig?.theme);
        }
      },
      setIsLoadingConfig: (isLoadingConfig: boolean) => {
        set({ isLoadingConfig });
      },
      setConfigLoadFailed: (configLoadFailed: boolean) => {
        set({ configLoadFailed });
      },
    }),
    {
      name: 'site-config',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        siteConfig: state.siteConfig,
        // isLoadingConfig не сохраняется, всегда начинается с true
      }),
    }
  )
);
